import React from "react";
import './style.scss';
import { image } from "../../../Assets";

const Footer = () =>{
    return(<>
        <footer>
            <div className="container main-footer">
                <div className="row">
                    <div className="col-lg-3 col-12 info-sec">                        
                        <img src={image.logo} alt="" />
                        <div className="col-lg-12 col-12">
                            <form action="https://formsubmit.co/contact@fractilestud.io" method="POST" id="contactform">                          
                                
                                <label>
                                    <input type="text" name="email" placeholder="Enter your email for newsletters"/>
                                </label>
                                <div className="sbt">
                                <input type="submit" value="Subscribe" />
                                </div>
                            </form>
                            {/* <img src={image.footerbg} alt=""  id="footerbg"/> */}
                        </div>
                    </div>    
                    <div className="col-lg-7 col-12 quicklink-wrapper">          
                        <div className="d-flex">
                            <div className="quicklink">
                                <h5>Home</h5>
                                <ul>
                                    <li>Conversion</li>
                                    <li>Clients</li>
                                    <li>Our Solutions</li>
                                    <li>Case Study</li>
                                    <li>Testimonials</li>
                                </ul>
                            </div>
                            <div className="quicklink">
                                <h5>About</h5>
                                <ul>
                                    <li>Our Approach</li>
                                    <li>Our Team</li>
                                </ul>
                            </div><div className="quicklink">
                                <h5>Industries</h5>
                                <ul>
                                    <li>Education</li>
                                    <li>Government</li>
                                    <li>Healthcare</li>
                                    <li>Transportation</li>
                                </ul>
                            </div>
                            <div className="quicklink">
                                <h5>Services</h5>
                                <ul>
                                    <li>BIM/VDC Services</li>
                                    <ul className="sublink">
                                        <li>Visualization</li>
                                        <li>Modeling</li>
                                        <li>BIM Management</li>
                                    </ul>
                                    <li>Project engineering Services</li>
                                    <ul className="sublink">
                                        <li>Shop Drawing Creation</li>
                                        <li>2D Overlay</li>
                                        <li>Document Management for RFIs, Submittals & Change Orders </li>
                                    </ul>
                                </ul>
                            </div>
                            <div className="quicklink">
                                <h5>Resources</h5>
                                <ul>
                                    <li>Blog</li>
                                    <li>Case Study</li>
                                    <li>Events</li>
                                </ul>
                            </div>
                        </div>
                    </div>  
                    <div className="col-lg-2 col-12">          
                        <div className="d-flex tw-flex-col tw-justify-between">
                            <ul className="socials">
                                <li>
                                    <img src={image.fbicon} alt="" />
                                </li>
                                <li>
                                    <img src={image.instaicon} alt="" />
                                </li>
                                <li>
                                    <img src={image.xicon} alt="" />
                                </li>
                            </ul>
                            <div className="d-flex tw-justify-between">
                                <span style={{color:'#157438',fontSize:' 12px'}}>Powered By Techxerro</span>
                                <span style={{color:'#157438',fontSize:'12px'}}>Privacy Policy</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="container copyright">
                <div className="row">
                    <div className="col-sm-6 col-12">
                        <span>Powered by <a href="https://techxerro.com/" target="_blank" style={{color:'#FBFF7E'}}>Techxerro</a></span>
                    </div>
                    <div className="col-sm-6 col-12 d-flex justify-content-end">
                        <span><a href="/privacy-policy" target="_blank">Privacy Policy</a></span>
                    </div>
                </div>
            </div> */}
        </footer>
    </>)
}

export default Footer;